import { atom } from "recoil";

export const pinnedSelectionState = atom<boolean>({
  key: 'pinnedSelectionState',
  default: false,
});
